<template>
 <a-button :disabled="disabled" @click="open">
  <sdFeatherIcons type="copy" size="16"/> Dupliceren
 </a-button>
 <a-modal :visible="visible" title="Product dupliceren" :footer="null"
          :closable="!loading" :mask-closable="!loading" :keyboard="!loading" @cancel="close">
  <template v-if="result">
   <a-alert type="success" show-icon :message="result.active ? 'De bestaande kopie is gevonden en staat inmiddels actief.' : 'De kopie is aangemaakt en staat inactief.'"/>
   <p class="mt-15">{{ result.name }}</p>
   <a-alert v-for="warning in result.warnings || []" :key="warning" type="warning" show-icon :message="warning" class="mb-15"/>
   <a :href="`/product/${result.id}`" class="ant-btn ant-btn-primary">Open de kopie</a>
   <a-button class="ml-10" @click="close">Sluiten</a-button>
  </template>
  <a-form v-else :model="form" layout="vertical" @finish="submit">
   <p>De opgeslagen productinstellingen, categorieën, subproducten, bestanden en koppelingen worden gekopieerd.
    Templates krijgen een eigen kopie met de nieuwe productnaam. De inhoud blijft gelijk.</p>
   <a-form-item label="Naam van de kopie" name="name" :validate-status="nameError ? 'error' : undefined" :help="nameError">
    <a-input v-model:value="form.name" :maxlength="255" :disabled="loading" placeholder="Vul de nieuwe productnaam in"/>
   </a-form-item>
   <p>De kopie staat standaard <strong>inactief</strong>.</p>
   <a-alert v-if="error" type="error" show-icon :message="error" class="mb-15"/>
   <a-button type="primary" html-type="submit" :loading="loading" :disabled="loading">Kopie maken</a-button>
   <a-button class="ml-10" :disabled="loading" @click="close">Annuleren</a-button>
  </a-form>
 </a-modal>
</template>

<script>
import {defineComponent, reactive, ref} from 'vue';
import {DataService} from '@/config/dataService/dataService';

export default defineComponent({
 name: 'ProductDuplicateButton',
 props: {
  productId: {type: [Number, String], required: true},
  productName: {type: String, default: ''},
  disabled: {type: Boolean, default: false},
 },
 setup(props) {
  const visible = ref(false);
  const loading = ref(false);
  const result = ref(null);
  const error = ref('');
  const nameError = ref('');
  const form = reactive({name: ''});
  let requestID = null;
  let attemptedName = null;
  const open = () => {
   if (props.disabled || loading.value) return;
   form.name = `${props.productName} kopie`.slice(0, 255);
   result.value = null;
   error.value = '';
   nameError.value = '';
   requestID = null;
   attemptedName = null;
   visible.value = true;
  };
  const close = () => {
   if (!loading.value) visible.value = false;
  };
  const submit = async () => {
   if (loading.value || result.value) return;
   const name = form.name.trim();
   nameError.value = name ? '' : 'Vul een naam voor de kopie in.';
   if (!name) return;
   if (!requestID || attemptedName !== name) {
    requestID = crypto.randomUUID();
    attemptedName = name;
   }
   loading.value = true;
   error.value = '';
   try {
    const response = await DataService.post(`/products/${props.productId}/duplicate`, {name, requestID});
    if (!response.data?.id) throw new Error('Missing product ID');
    result.value = response.data;
   } catch (err) {
    const data = err?.response?.data;
    nameError.value = data?.errors?.name?.[0] || '';
    error.value = data?.errors?.product?.[0]
     || (err?.response?.status === 403 ? 'Je hebt geen rechten om dit product te dupliceren.' : '')
     || (data?.message && !data?.errors ? data.message : '')
     || (nameError.value ? '' : 'De kopie kon niet worden bevestigd. Je invoer is bewaard; probeer het opnieuw.');
   } finally {
    loading.value = false;
   }
  };
  return {visible, loading, result, error, nameError, form, open, close, submit};
 },
});
</script>
